import {
    selectAssetStatus,
    selectBuCode,
    selectOrderType,
} from '@repo/api-adapters/selectors/customer-assets.selectors';

import { getServiceBaseUrl } from '@/api/helpers.api';
import { useAssetServices } from '@/hooks/asset-services.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { useIsTimeWindowSelectionEnabled } from '@/hooks/time-window-update.hooks';
import { getAppConfig } from '@/utils/window.utils';

export const useIsEditModeAvailable = (): boolean => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const services = useAssetServices(data);
    const config = getAppConfig();
    const featureContext = {
        assetType,
        orderType: selectOrderType(data),
        assetStatus: selectAssetStatus(data),
        hasDeliveryServices: services.some((service) => service.isDelivery === true),
        hasProvidedServices: services.some((service) => service.isDelivery !== true),
    };
    const coworkerBaseUrl = getServiceBaseUrl(config.api.services.orderTaking, 'coworker');
    const buCode = selectBuCode(data) ?? '';
    const isDeliveryTimeWindowSelectionEnabled = useIsTimeWindowSelectionEnabled(
        'delivery',
        featureContext,
        coworkerBaseUrl,
        buCode
    );
    const isProvidedServiceTimeWindowSelectionEnabled = useIsTimeWindowSelectionEnabled(
        'providedService',
        featureContext,
        coworkerBaseUrl,
        buCode
    );

    return isDeliveryTimeWindowSelectionEnabled || isProvidedServiceTimeWindowSelectionEnabled;
};
